<template>
  <div ref="root">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import { ref } from "vue";

const root = ref<HTMLElement>();

useFocusTrap(root, {
  immediate: true,
  initialFocus: () => root.value!,
  allowOutsideClick: true,
});
</script>

<style lang="scss" scoped>
div {
  outline: 0 none;
}
</style>
